export var SSO_TYPE_SAML = "saml";
export var SSO_TYPE_NONE = "none";
export var SAML_REQUEST_TYPE_POST = "POST";
export var SAML_REQUEST_TYPE_REDIRECT = "REDIRECT";
export var SAML_REQUEST_TYPES = [SAML_REQUEST_TYPE_POST, SAML_REQUEST_TYPE_REDIRECT];
export var RESOLVED_SAML_REQUEST_TYPES_KEY = [
    { label: "admin.components.samlSingleSignOn.signUpOptions.requestType.post", value: SAML_REQUEST_TYPE_POST },
    { label: "admin.components.samlSingleSignOn.signUpOptions.requestType.redirect", value: SAML_REQUEST_TYPE_REDIRECT }
];
